(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshow(root) {
      if (root.dataset.mbInitialized === 'true') return;
      root.dataset.mbInitialized = 'true';

      var track = root.querySelector('[data-mb-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mb-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mb-dot]'));
      var prevBtn = root.querySelector('[data-mb-prev]');
      var nextBtn = root.querySelector('[data-mb-next]');
      var total = slides.length;
      var index = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
      var timer = null;

      if (total <= 1) return;

      function render() {
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goTo(i) {
        index = (i + total) % total;
        render();
      }

      function next() {
        goTo(index + 1);
      }

      function prev() {
        goTo(index - 1);
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        timer = setInterval(next, speed);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          startAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          startAutoplay();
        });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      var startX = null;
      track.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          stopAutoplay();
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var deltaX = e.changedTouches[0].clientX - startX;
          if (Math.abs(deltaX) > 40) {
            if (deltaX < 0) {
              next();
            } else {
              prev();
            }
          }
          startX = null;
          startAutoplay();
        },
        { passive: true }
      );

      render();
      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('[data-mb-slideshow]').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-mb-slideshow]');
      if (root) initSlideshow(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
